import { lastValueFrom } from 'rxjs';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { AccountService } from "../account.service";
import { AuthService } from 'src/app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-account',
  templateUrl: './view-account.component.html',
  styleUrls: ['./view-account.component.scss']
})
export class ViewAccountComponent {

  public account: any;
  public accountTaxes: any;
  public selected: number = 0;

  public isLoaded: boolean = true;
  public validationCode: string = '';
  public errorMessage: string = '';
  public idCopy: string = '';

  constructor(private accountService: AccountService,
    public authService: AuthService,
  private toastr: ToastrService,
    private modalService: NgbModal) {
    this.accountService.getAccount().then(
      value => {
        this.account = value;
      }
    ).then(() => {
      this.selected = this.account.personType == 0 ? 1 : 2;
    });
    this.accountService.getAccountTaxes().then(
      value => {
        this.accountTaxes = value;
      }
    );
  }

  copyId(id: string): void {
    if (!id) {
      this.toastr.warning('Não há nada para copiar', 'Aviso', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
      return;
    }
    navigator.clipboard.writeText(id).then(() => {
      this.toastr.success('Copiado com sucesso!', 'Sucesso', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
    }).catch(err => {
      this.toastr.error('Erro ao copiar', 'Erro', {
        timeOut: 2000,
        positionClass: 'toast-top-right'
      });
    });
  }

  async isValidTotp() {
    let isValid: boolean = false;
    await this.authService.validateTotpCode(this.validationCode).then(
      value => {
        isValid = value.isValid;
      }
    );
    return isValid;
  }

  async validateTotp() {
    this.isLoaded = false;
    let isValidTotp = await this.isValidTotp();
    if (isValidTotp) {
      this.modalService.dismissAll();
      await lastValueFrom(this.accountService.setWithdrawAutomatic(!this.account.withDrawConfiguration.isAutomatic)).then(() => {
        this.accountService.getAccount().then(
          value => {
            this.account = value;
          }
        ).then(() => {
          this.selected = this.account.personType == 0 ? 1 : 2;
        });
        this.accountService.getAccountTaxes().then(
          value => {
            this.accountTaxes = value;
          }
        );

        this.toastr.success('Operação realizada com sucesso!', 'Sucesso!', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      });

    } else {
      this.errorMessage = 'Código de autenticação inválido!';
    }
    this.isLoaded = true;
  }
}
